import React from 'react';
import './Clients.css';

const Clients = () => {
  const clientSegments = [
    {
      icon: '💡',
      title: 'Emprendedores y Startups',
      description: 'Validación y estructuración de ideas de negocio con el apoyo de IA',
      color: 'orange'
    },
    {
      icon: '📈',
      title: 'PYMES en Crecimiento',
      description: 'Optimización de procesos, digitalización y mejora en la toma de decisiones',
      color: 'purple'
    },
    {
      icon: '🏛️',
      title: 'Empresas Tradicionales',
      description: 'Innovación a través de transformación digital y machine learning',
      color: 'orange'
    },
    {
      icon: '🚀',
      title: 'Aceleradoras e Incubadoras',
      description: 'Herramientas para ayudar a emprendedores en su crecimiento',
      color: 'purple'
    }
  ];

  return (
    <section id="clientes" className="clients">
      <div className="clients-container">
        <div className="section-header">
          <h2 className="section-title">Nuestros Clientes</h2>
          <p className="section-subtitle">
            Soluciones adaptadas a cada tipo de negocio
          </p>
        </div>

        <div className="clients-grid">
          {clientSegments.map((segment, index) => (
            <div key={index} className={`client-card client-${segment.color}`}>
              <div className="client-icon">{segment.icon}</div>
              <h3 className="client-title">{segment.title}</h3>
              <p className="client-description">{segment.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;

